export default {
    breadcrumb: {
      home: '首页',
      current: '开放信息',
    },
    sections: [
      {
        id: 'profile',
        title: '个人信息',
        items: [
          '<strong>姓名：</strong>高博宇',
          '<strong>部门：</strong>暨南大学网络空间安全学院、广东智慧教育研究院',
          '<strong>职称：</strong>副教授',
          '<strong>学位：</strong>博士学位',
          '<strong>毕业院校：</strong>韩国建国大学',
          '<strong>电子邮箱：</strong><a href="mailto:bygao@jnu.edu.cn">bygao@jnu.edu.cn</a>',
        ],
      },
      {
        id: 'bio',
        title: '个人简介',
        paragraphs: [
          '高博宇，暨南大学网络空间安全学院副教授、硕导、广东智慧教育研究院院长助理。从 2011 -起在韩国建国大学 DCRC 研究中心（主任：Jee-In Kim 教授、CHI 2015 Local Hero）与 VR 实验室（主任：HyungSeok Kim 教授，指导教授）从事虚拟现实多通道可信交互相关研究，作为核心成员参与多项韩国自然科学基金重点研发计划项目。2018 - 2 博士毕业后留校工作半-，同- 9 以副教授入职暨南大学，主持国家自然科学基金面上项目、国家重点研发计划项目子课题、国家自然科学基金青-项目、广东省自然科学基金面上项目、广州市基础与应用基础研究青-项目、企业合作项目等 10 余项科研项目。',
          '已发表国际期刊与会议论文 30 余篇，其中以第一或通讯作者身份发表 26 篇 SCI 索引 / CCF 列表期刊会议论文，包括 IEEE VR（CCF-A）、IEEE Transactions on Visualization and Computer Graphics（CCF-A）、International Journal of Human-Computer Studies（CCF-A）、IEEE Transactions on Human-Machine Systems（CCF-B）、International Journal of Human-Computer Interaction（CCF-B）、IEEE Transactions on Industrial Informatics（中科院一区 Top）等。曾获 HHME 2023 CHCI 最佳论文奖、韩国计算机大会 2019 -最佳论文奖、2019 -度吴渔夫科技创新育人奖、2021 -度广东省计算机学会科学进步奖三等奖等。',
        ],
      },
      {
        id: 'education',
        title: '学习经历',
        items: [
          '2013.09 - 2018.02：韩国建国大学 · 网络多媒体工程专业 · 工学博士',
          '2011.09 - 2013.08：韩国建国大学 · 网络多媒体工程专业 · 工学硕士',
          '2009.03 - 2010.03：韩国建国大学 · 计算机工程专业 · 公派交换生',
          '2007.09 - 2011.07：西南民族大学 · 计算机科学与技术专业 · 工学学士',
        ],
      },
      {
        id: 'experience',
        title: '工作经历',
        items: [
          '2021.10 - 至今：暨南大学 · 广东智慧教育研究院 · 院长助理',
          '2018.09 - 至今：暨南大学 · 网络空间安全学院 · 副教授',
          '2018.03 - 2018.08：韩国建国大学 · Social Eco-Tech 研究所 · 博士后研究员',
          '2013.09 - 2018.02：韩国建国大学 · VR 研究所 · 博士研究助理',
          '2012.09 - 2013.08：韩国建国大学 · VR 研究所 · 硕士研究助理',
        ],
      },
      {
        id: 'research',
        title: '研究方向',
        items: ['虚拟现实', '人机交互', '人工智能与智慧教育', '应用安全'],
      },
      {
        id: 'recruiting',
        title: '招生情况',
        paragraphs: [
          '每-拟招生专硕与学硕共 2-3 名，欢迎对人机交互、虚拟现实、人工智能智慧教育或应用安全感兴趣，且学习态度积极、目标明确、自我激励强烈的研究生与本科生发邮件联系。欢迎保研推免生联系并尽早进入课题组，更有利于在硕士阶段发表高质量论文。',
          '课题组与国内外多所知名虚拟现实与人机交互团队保持合作，包括香港理工大学、美国 Adobe Research 研究所、美国俄亥俄州立大学、清华大学、中科院软件所、北京理工大学、澳洲 La Trobe University、韩国 Konkuk University 等，可推荐优秀毕业生前往继续深造。',
        ],
      },
      {
        id: 'publications',
        title: '主要论文',
        subsections: [
          {
            title: '代表性期刊论文（* 通讯作者）',
            items: [
              '[1] H. Tu*, B. Y. Gao*, H. Wu, F. Lyu, “Text Pin: Improving Text Selection with Mode-Augmented Handles on Touchscreen Mobile Devices”, International Journal of Human-Computer Studies, 2023.',
              '[2] B. Y. Gao, Z. Mai, H. Tu, H. Duh, “Effects of Body Parts and Transfer Functions on Body-centric Locomotion in Virtual Reality”, IEEE Transactions on Visualization and Computer Graphics, 2022.',
              '[3] H. Tu, Q. Huang, Y. Zhao, B. Y. Gao*, “Effects of Holding Postures on User-Defined Touch Gestures for Tablet Interaction”, International Journal of Human-Computer Studies, 2020.',
              '[4] G. Du, Y. Liang, B. Y. Gao*, et al., “A Cognitive Joint Angle Compensation System Based on Self-Feedback Fuzzy Neural Network with Incremental Learning”, IEEE Transactions on Industrial Informatics, 2021.',
              '[5] G. Du, Z. Wang, B. Y. Gao*, et al., “A Convolution Bidirectional Long Short-Term Memory Neural Network for Driver Emotion Recognition”, IEEE Transactions on Intelligent Transportation Systems, 2020.',
              '[6] G. Du, B. Zhang, C. Li*, B. Y. Gao*, P. X. Liu, “Natural Human-Machine Interface with Gesture Tracking and Cartesian Platform for Contactless Electromagnetic Force Feedback”, IEEE Transactions on Industrial Informatics, 2020.',
              '[7] B. Y. Gao, H. S. Kim*, H. Lee, J. Lee, J.-I. Kim, “Effects of Continuous Auditory Feedback on Drawing Trajectory-based Finger Gestures”, IEEE Transactions on Human-Machine Systems, 2018.',
              '[8] B. Y. Gao, B. Kim, J.-I. Kim, H. S. Kim*, “Amphitheater Layout with Egocentric Distance-based Item Sizing and Landmarks for Browsing in Virtual Reality”, International Journal of Human-Computer Interaction, 2019.',
              '[9] F. Huang, C. Li, B. Y. Gao*, et al., “Deep Attentive Multimodal Network Representation Learning for Social Media Images”, ACM Transactions on Internet Technology, 2021.',
              '[10] B. Y. Gao, Z. Chen, X. Chen, et al., “The Effects of Audiovisual Landmarks on Spatial Learning and Recalling for Image Browsing Interface in Virtual Environments”, Journal of Systems Architecture, 2021.',
              '[11] N. Qiu, B. Y. Gao*, H. Tu, F. Huang, Q. Guan, W. Luo*, “LDGC-SR: Integrating Long-range Dependencies and Global Context Information for Session-based Recommendation”, Knowledge-Based Systems, 2022.',
            ],
          },
          {
            title: '代表性会议论文（* 通讯作者）',
            items: [
              '[1] B. Y. Gao, Z. Mai, H. Tu*, H. B. L. Duh, “Evaluation of Body-Centric Locomotion with Different Transfer Functions in Virtual Reality”, IEEE VR 2021.',
              '[2] N. Qiu, B. Y. Gao*, F. Huang, H. Tu, W. Luo*, “Incorporating Global Context into Multi-Task Learning for Session-based Recommendation”, KSEM 2021.',
              '[3] Y. Lu, B. Y. Gao*, H. Tu, W. Luo, H. Kim, “Effects of Different Proximity-based Feedback on Virtual Hand Pointing in Virtual Reality”, CGI 2021.',
              '[4] J. Wang, B. Y. Gao*, “Analysis of Multi-attribute User Authentication to Against Man-in-the-room Attack in Virtual Reality”, HCII 2021.',
              '[5] S. Xiao, X. Ye, Y. Guo, B. Y. Gao, J. Long*, “Transfer of Coordination Skill to the Unpracticed Hand in Immersive Environments”, IEEE VR 2020.',
              '[6] B. Y. Gao*, J. Lee, H. Tu, W. Seong, H. S. Kim, “The Effects of Avatar Visibility on Behavioral Response with or without Mirror-Visual Feedback in Virtual Environments”, IEEE VR 2020.',
              '[7] Y. Lu, B. Y. Gao*, J. Long, J. Weng, “Hand Motion with Eyes-free Interaction for Authentication in Virtual Reality”, IEEE VR 2020.',
              '[8] B. Y. Gao, Y. Lu, H. S. Kim, B. Kim, J. Long, “Spherical Layout with Proximity-based Multimodal Feedback for Eyes-free Target Acquisition in Virtual Reality”, HCI International 2019.',
              '[9] B. Y. Gao, J.-I. Kim, H. S. Kim*, “Sensory and Perceptual Consistency for Believable Response in Action-Feedback Loop”, CGI 2018.',
              '[10] B. Y. Gao, H. S. Kim*, B. Kim, J.-I. Kim, “Artificial Landmarks to Facilitate Spatial Learning and Recalling for Curved Visual Wall Layout in Virtual Reality”, IEEE BigComp 2018.',
              '[11] B. Y. Gao, H. S. Kim*, H. Lee, J. Lee, J.-I. Kim, “Use of Sound to Provide Occluded Visual Information in Touch Gestural Interface”, ACM CHI 2015.',
            ],
          },
        ],
      },
      {
        id: 'projects',
        title: '承担课题',
        paragraphs: ['主持科研项目（截至 2023.09）：'],
        items: [
          '1. 国家自然科学基金面上项目（62372212，2024.01-2027.12）',
          '2. 国家重点研发计划项目子课题（2022YFC3303604，2022.11-2025.10）',
          '3. 国家自然科学基金青-项目（61902147，2020.01-2022.12）',
          '4. 广东省自然科学基金面上项目（2021.01-2023.12）',
          '5. 广州市基础与应用基础研究青-项目（2021.03-2023.03）',
          '6. 暨南大学中央高校专项基金（2023.01-2024.12）',
          '7. 暨南大学虚拟仿真实验教学培育项目（2021.05-2022.05）',
          '8. 暨南大学中央高校青-基金（21619312，2019.01-2021.12）',
          '9. 符号计算与知识工程教育部重点实验室开放课题（93K172019K02，2019.01-2020.12）',
          '10. 暨南大学高层次引进人才启动经费（2018.09-2021.09）',
        ],
      },
      {
        id: 'courses',
        title: '讲授课程',
        items: ['虚拟现实技术', '人机交互导论', '移动终端安全', '智能系统与制造'],
      },
      {
        id: 'service',
        title: '社会职务',
        items: [
          '1. CCF 人机交互专委会执行委员、CCF 虚拟现实与可视化技术专委会执行委员、CCF 计算机辅助设计与图形学专委会执行委员、CSIG 虚拟现实专委会执行委员',
          '2. IEEE VR 2023 3DUI Contest Chairs、ACM SUI 2023 Publicity Chairs、HHME 2023 宣传主席、Chinese CHI 2022 学生竞赛主席、HHME 2022 CHCI 技术展示共同主席、CASA 2022 博士论坛主席、ICVR 2021 研讨会主席、ACM CHI 2015/2016/2017 数据管理主席、ICACHI 秘书处（2019-2022）等',
          '3. IEEE VR 2024 程序委员、IEEE ISMAR 2022/2023 程序委员、ACM CHI 2021/2020 Late-Breaking Work 程序委员、Chinese CHI 2021/2020 程序委员、ChinaVR 2021/2020 程序委员',
          '4. IEEE TVCG、The Visual Computer、IEEE VR 2019/2020/2021、ACM CHI 2019/2020/2021、ICMI 2019、ACM VRST 2017/2018 等审稿人',
        ],
      },
    ],
  };
